// Minimal JavaScript bundle for public pages
// Only includes controllers actually used on public-facing pages
// This significantly reduces bundle size vs application.js

import "@hotwired/turbo-rails"
import { Application } from "@hotwired/stimulus"

// Initialize Stimulus application
const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

// Import npm package controllers
import ScrollReveal from 'stimulus-scroll-reveal'

// Import only controllers used on public pages
import VideoAutoplayController from "../controllers/video_autoplay_controller"
import PublicNavController from "../controllers/public_nav_controller"
import RecaptchaController from "../controllers/recaptcha_controller"
import BookingFormController from "../controllers/booking_form_controller"
import GallerySliderController from "../controllers/gallery_slider_controller"
import LazyInstagramController from "../controllers/lazy_instagram_controller"
import SignatureController from "../controllers/signature_controller"
import AutofillWaiverController from "../controllers/autofill_waiver_controller"
import AccommodationAvailabilityController from "../controllers/accommodation_availability_controller"
import CountdownController from "../controllers/countdown_controller"
import PublicWizardController from "../controllers/public_wizard_controller"
import PublicDivesController from "../controllers/public_dives_controller"
import PublicAccommodationController from "../controllers/public_accommodation_controller"
import PublicDatePickerController from "../controllers/public_date_picker_controller"
import HeroDatePickerController from "../controllers/hero_date_picker_controller"
import AccomDatePickerController from "../controllers/accom_date_picker_controller"
import FormPersistController from "../controllers/form_persist_controller"
import BooleanToggleButtonsController from "../controllers/boolean_toggle_buttons_controller"
import WaiverSubmitGateController from "../controllers/waiver_submit_gate_controller"

// Register npm package controllers
application.register("scroll-reveal", ScrollReveal)

// Register public page controllers
application.register("video-autoplay", VideoAutoplayController)
application.register("public-nav", PublicNavController)
application.register("recaptcha", RecaptchaController)
application.register("booking-form", BookingFormController)
application.register("gallery-slider", GallerySliderController)
application.register("lazy-instagram", LazyInstagramController)
application.register("signature", SignatureController)
application.register("autofill-waiver", AutofillWaiverController)
application.register("accommodation-availability", AccommodationAvailabilityController)
application.register("countdown", CountdownController)
application.register("public-wizard", PublicWizardController)
application.register("public-dives", PublicDivesController)
application.register("public-accommodation", PublicAccommodationController)
application.register("public-date-picker", PublicDatePickerController)
application.register("hero-date-picker", HeroDatePickerController)
application.register("accom-date-picker", AccomDatePickerController)
application.register("form-persist", FormPersistController)
application.register("boolean-toggle-buttons", BooleanToggleButtonsController)
application.register("waiver-submit-gate", WaiverSubmitGateController)
